import fuhrpark from "../assets/startseite/6.jpeg";
import brunnen from "../assets/startseite/8.jpeg";
import zaun from "../assets/startseite/5.jpeg";
interface SliderImage {
  id: number;
  src: string;
  alt: string;
  title: string;
  description: string;
}

export const sliderConfig: SliderImage[] = [
  {
    id: 1,
    src: fuhrpark,
    alt: "Gartenpflege",
    title: "Zuverlässige Gartenpflege",
    description: "Regelmäßige Pflege für einen gepflegten Garten",
  },
  {
    id: 2,
    src: zaun,
    alt: "Moderne Gartengestaltung",
    title: "Professionelle Gartengestaltung",
    description: "Verwandeln Sie Ihren Garten in eine Oase der Entspannung",
  },
  {
    id: 3,
    src: brunnen,
    alt: "Landschaftsbau",
    title: "Individueller Landschaftsbau",
    description: "Kreative Lösungen für Ihren Außenbereich",
  },
];
